import React from 'react'
import { connect } from 'dva'
import { bindActionCreators } from 'redux'

import questionSelector from 'models/question/selectors'
import * as questionActions from 'models/question/actions'
import * as scoreActions from 'models/score/actions'

import Question from './Question'

const QuestionContainer = ({ currentQuestion, currentResult, currentAnswer, actions }) => {
  function toAnswer(answer) {
    actions.question.setAnswer(answer)

    const getRandResult = results => results[Math.floor(Math.random()*results.length)]

    const result = getRandResult(answer.results)

    actions.question.setResult(result)
    actions.score.modify(result.effects)
  }

  return (
    <Question question={currentQuestion} result={currentResult} currentAnswer={currentAnswer} toAnswer={toAnswer} />
  )
}

function mapStateToProps(state, ownProps) {
  return Object.assign({},
    questionSelector(state, ownProps),
  )
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      question: bindActionCreators(questionActions, dispatch),
      score: bindActionCreators(scoreActions, dispatch),
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(QuestionContainer)



// WEBPACK FOOTER //
// ./src/components/Question/index.js